export default "__VITE_ASSET__Dhu00sLx__"